import React from 'react'
import { observer } from 'mobx-react'
import Avatar from 'components/Avatar'
import Icon from 'components/Icon'
import { IconButton } from 'components/IconButton'
import { Dropdown, DropdownItem, DropdownItemTitle } from 'components/Dropdown'
import JobNotesViewModel from '../JobNotesViewModel'
import JobNoteItemViewModel from '../JobNoteItemViewModel'
import styles from './JobNoteItem.sass'

interface Props {
  vm: JobNotesViewModel
  note: JobNoteItemViewModel
}

export default observer(function JobNoteItem({ vm, note }: Props) {
  return (
    <div className={styles.root} data-test={`job-note-${note.id}`}>
      <div className={styles.header}>
        <span className={styles.avatar}>
          <Avatar subject={note.author} size={24} />
        </span>
        <div className={styles.meta}>
          <span className={styles.author} title={note.displayName}>
            {note.displayName}
          </span>
          <div className={styles.subline}>
            <span className={styles.time}>{note.formattedTime}</span>
            {note.role && <span className={styles.role}>{note.role}</span>}
          </div>
        </div>
        {vm.canDelete(note) && (
          <Dropdown
            autoDismiss
            dataTest={`job-note-menu-${note.id}`}
            button={
              <IconButton className={styles.menu}>
                <Icon name="more" />
              </IconButton>
            }
          >
            <DropdownItem
              icon={<Icon name="delete" />}
              onClick={() => vm.deleteNote(note)}
            >
              <DropdownItemTitle>Delete</DropdownItemTitle>
            </DropdownItem>
          </Dropdown>
        )}
      </div>

      <p className={styles.body} data-private>
        {note.mentions.map((mention) => (
          <span key={mention} className={styles.mention} title={mention}>
            {mention}
          </span>
        ))}
        {note.body}
      </p>
    </div>
  )
})
